import { CalloutBox } from 'components/Docs/CalloutBox';
import ExposedApiKeys from "../../../../contents/docs/_snippets/exposed-api-keys.mdx";
import * as React from 'react';
export default {
  CalloutBox,
  ExposedApiKeys,
  React
};